var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_1510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1553 0.55957C8.54822 0.55957 0.759521 8.38657 0.759521 18.0409C0.759521 27.6953 8.54822 35.5223 18.1553 35.5223C27.7624 35.5223 35.5511 27.6953 35.5511 18.0409C35.5511 8.38657 27.7624 0.55957 18.1553 0.55957Z",
    fill: "#2E1A47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0584 16.4588L27.5053 7.75977H25.7407L19.2745 15.313L14.11 7.75977H8.15332L15.9631 19.1816L8.15332 28.3039H9.91811L16.7466 20.3274L22.2007 28.3039H28.1573L20.058 16.4588H20.0584ZM10.554 9.09482H13.2646L25.7415 27.0296H23.0309L10.554 9.09482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_1510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7916,
    height: 34.9627,
    fill: "white",
    transform: "translate(0.759521 0.55957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.594b48510ab87eedc758db699bb5ec63.svg";
export { ForwardRef as ReactComponent };